import { createRef } from "react";
import { ReviewsResult } from "../../../graphql/operations";
import CityNavigation from "../../Cards/CityNavigation";
import ReviewsCarousel from "../Listing/ReviewsCarousel";
import data from "./SumoData";
import styles from "./SumoLanding.module.scss";
import SumoSection from "./SumoSection";

interface LandingProps {
  reviews: ReviewsResult;
}

export default function SumoLanding({ reviews }: LandingProps) {
  const scrollTo = (divRef) => {
    if (divRef) {
      divRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const sumoTypesContent = [
    {
      id: "watch",
      title: "Watch Sumo Morning Practice",
      image:
        "https://res.cloudinary.com/dbm1qiew0/image/upload/e_art:red_rock/q_auto,f_auto,dpr_2.0,h_150,c_scale/v1718676164/sumo-landing-page/9c69b8ae-44ec-428b-9095-2207708ab101.jpg",
      description:
        "Witness the intense training sessions of sumo wrestlers in the early morning",
      reviewProductTitle: "Sumo Morning Practice Tour",
    },
    {
      id: "challenge",
      title: "Challenge Sumo Wrestlers",
      image:
        "https://res.cloudinary.com/dbm1qiew0/image/upload/e_art:red_rock/q_auto,f_auto,dpr_2.0,h_150,c_scale/v1707812092/products/9374c341-6d87-4064-85f2-80bdb3edfb6b/images/106e7024-b1a1-4d1d-945c-b6808d2fa6a4.jpg",
      description:
        "Get up close and personal with professional sumo wrestlers and learn about their daily routines and enjoy a satisfying lunch meal",
      reviewProductTitle: "Authentic Sumo Experience Tour",
    },
    {
      id: "grand",
      title: "Watch Grand Tournament",
      image:
        "https://res.cloudinary.com/dbm1qiew0/image/upload/e_art:red_rock/q_auto,f_auto,dpr_2.0,h_150,c_scale/v1700468660/products/3e954323-fe3f-411e-955e-ca39b760883c/images/5e93fa12-6af5-4b76-93ce-0a7a4e02a2c8.jpg",
      description:
        "Get tickets to sumo wrestling tournaments held in Tokyo, a guide will accompany you to enjoy the show",
      reviewProductTitle: "Grand Sumo Tournament Tour",
    },
  ];

  const refs = sumoTypesContent.reduce((acc, value) => {
    acc[value.id] = createRef<HTMLDivElement>();
    return acc;
  }, {});

  return (
    <>
      <section className={styles.SumoHero}>
        <div className="AppLayout">
          <div className={styles.SumoHeroContent}>
            <div className={styles.SumoHeroText}>
              <h1>Experience the Power and Tradition of Sumo</h1>
              <p>
                Immerse yourself in the world of sumo wrestling and witness the
                awe-inspiring strength and skill of these legendary athletes.
              </p>
            </div>
            <div className={styles.SumoHeroImageContainer}>
              <img
                src="https://res.cloudinary.com/dbm1qiew0/image/upload/f_auto,q_auto,dpr_2,h_350/v1718848726/sumo-landing-page/result.png"
                alt=""
                className={styles.SumoMainImg}
              />
              <img
                src="https://res.cloudinary.com/dbm1qiew0/image/upload/f_auto,q_auto/v1718848714/sumo-landing-page/kanji.png"
                alt=""
                className={styles.PowerKanji}
              />
              <img
                src="https://res.cloudinary.com/dbm1qiew0/image/upload/f_auto,q_auto/v1718848713/sumo-landing-page/dosi.png"
                alt=""
                className={styles.Doskoi}
              />
            </div>
          </div>
        </div>
      </section>
      <div className="AppLayout">
        <section>
          <h2
            style={{
              textAlign: "center",
              fontWeight: "bold",
              marginBottom: 40,
              marginTop: 20,
              fontSize: 32,
            }}
          >
            Choose from 3 types of Sumo Experiences
          </h2>
          <div className={styles.SumoTypesContainer}>
            {sumoTypesContent.map((s, index) => {
              return (
                <div className={styles.SumoTypeContent} key={index}>
                  <img
                    src={s.image}
                    alt={s.title}
                    style={{ marginBottom: 15 }}
                  />
                  <h3>{s.title}</h3>
                  <p>{s.description}</p>
                  <div
                    className={styles.LearnMoreBtn}
                    onClick={() => scrollTo(refs[s.id])}
                  >
                    Learn More
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        {data.map((s, index) => {
          return (
            <>
              <div ref={refs[sumoTypesContent[index].id]} key={index}>
                <SumoSection data={s} />
              </div>
              <div>
                {reviews.totalRecords > 0 && (
                  <>
                    <h3
                      style={{
                        fontWeight: "bold",
                        marginBottom: 20,
                        marginTop: 60,
                        fontSize: 22,
                      }}
                    >
                      What are people saying about our{" "}
                      {sumoTypesContent[index].reviewProductTitle} in Tokyo
                    </h3>
                    <ReviewsCarousel
                      reviewList={reviews.records.filter((r) =>
                        s.tours.some((tour) => tour.id === r.product.id)
                      )}
                    />
                  </>
                )}
              </div>
            </>
          );
        })}

        <h2 style={{ marginTop: 64, marginBottom: 15 }}>
          Find More Local Tours in Japan
        </h2>
        <CityNavigation countryId={"a032f3f0-81a8-41ac-bf04-f46e3be952a5"} />
      </div>
    </>
  );
}
